import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformClientResponse } from 'helpers/core';

const handler = ({ httpClient }, countrySlug) => {
  const endpoint = URLS.cms.getLegalContent(countrySlug);
  return httpClient
    .get(endpoint)
    .then(transformClientResponse)
    .then(data => data.content);
};

export default makeEntityScaffold('SAGA.API.CMS_LEGAL_CONTENT', handler);
